import { Title } from 'components/atoms/Title';
import { SizesEnum } from 'components/atoms/Title/Title.enum';
import useAuthStatus from 'hooks/Authentication/useAuthStatus';
import useRedirectFromAuth from 'hooks/Authentication/useRedirectFromAuth';
import type { FC, PropsWithChildren } from 'react';

const AuthPageLayout: FC<
  PropsWithChildren<{
    title: string;
    subTitle: string;
    renderAside?: () => JSX.Element;
  }>
> = ({ title, subTitle, children, renderAside }) => {
  const { isAuthenticated } = useAuthStatus();

  useRedirectFromAuth();

  return isAuthenticated ? null : (
    <div className="flex">
      <main className="flex pt-[8rem] flex-[7] flex-col min-h-screen items-center">
        <div className="pb-10 text-center ">
          <Title type={SizesEnum.h2} className=" text-primary-800">
            {title}
          </Title>

          <p className="text-primary-600 text-lg text-center">{subTitle}</p>

          <div className="max-w-[400px] mt-8 mx-auto">{children}</div>
        </div>
      </main>
      <aside className="relative overflow-y-hidden xl:flex m-4 bg-taxes-50 rounded-3xl md:px-12 pt-32 flex-[3] min-w-[32rem] flex-col items-center">
        {renderAside?.()}
      </aside>
    </div>
  );
};

export default AuthPageLayout;
